import React from 'react';

export default function AdminPage() {
  return <div style={{ height: '75%' }}></div>;
}
